<script setup lang="ts">
import { catalogPaginationPages } from "~/utils/catalogPagination";

const props = defineProps<{ currentPage: number; lastPage: number }>();
const route = useRoute();
const { isMobile } = useDevice();
const pages = computed(() => catalogPaginationPages(props.currentPage, props.lastPage, isMobile ? 5 : 11));
const pageLink = (page: number) => ({
  path: route.path,
  query: { ...route.query, page: page > 1 ? String(page) : undefined },
});
watch(() => props.currentPage, () => {
  if (import.meta.client) window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>

<template>
  <nav v-if="lastPage > 1" :aria-label="$t('pagination')" class="el-pagination is-background products-pagination">
    <NuxtLink
      v-if="currentPage > 1"
      :to="pageLink(currentPage - 1)"
      :aria-label="$t('previous_page')"
      class="btn-prev"
      replace
    ><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2" /></svg></NuxtLink>
    <span v-else class="btn-prev is-disabled" aria-hidden="true">‹</span>
    <ul class="el-pager">
      <li v-for="page in pages" :key="page" :class="{ 'is-active': page === currentPage }">
        <NuxtLink
          v-if="typeof page === 'number'"
          :to="pageLink(page)"
          :aria-current="page === currentPage ? 'page' : undefined"
          replace
        >{{ page }}</NuxtLink>
        <span v-else aria-hidden="true">…</span>
      </li>
    </ul>
    <NuxtLink
      v-if="currentPage < lastPage"
      :to="pageLink(currentPage + 1)"
      :aria-label="$t('next_page')"
      class="btn-next"
      replace
    ><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" /></svg></NuxtLink>
    <span v-else class="btn-next is-disabled" aria-hidden="true">›</span>
  </nav>
</template>

<style scoped>
.products-pagination .el-pager a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  color: inherit;
}
.products-pagination .el-pager li {
  font-size: var(--fs-0);
}
.products-pagination a:focus-visible { outline: 2px solid var(--el-color-primary); outline-offset: 2px; }
</style>
